import { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "../config";

interface I18nProviderProps {
  children: ReactNode;
}

/**
 * Provider für i18n. Stellt die Übersetzungsinstanz bereit, damit t()
 * Schlüssel stets aus den Locale-Dateien auflöst (keine Rohschlüssel im UI).
 * Das Feature-Flag I18N_ENABLED steuert nur optionale Features (z. B. Sprachumschalter).
 */
export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
